var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"element":"virtual-shop-upgrade-tip"}},[_c('div',[_c('div',[_vm._v(_vm._s(_vm.$t('shop.on_busy_upgrade_tip')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }